import { useWebSocket } from '@eptai/eptai-app-components';

/**
 * Returns the WebSocket context. The app mounts WebSocketProvider at the root,
 * so null only happens outside the provider (or before it mounts).
 */
export function useRequiredWebSocket() {
  const webSocket = useWebSocket();
  if (!webSocket) {
    throw new Error('useRequiredWebSocket must be used within WebSocketProvider');
  }
  return webSocket;
}
